import { DropdownMenu, PaginatedDropdownMenu } from '../../../../../../components';
import withDropdownField from '../../../../../taboola-common-frontend-modules/validations/components/hoc/withDropdownField';

export const PaginatedDropdownField = withDropdownField(PaginatedDropdownMenu);

export default withDropdownField(DropdownMenu);
